import { SKIP_BASIC_AUTH_HEADER } from '../../API/constants';

function UserInfo(core) {
    this.client = core.client;
}

const baseUrl = `../api/v1/personal/info?fields=extension,name,language,email&${SKIP_BASIC_AUTH_HEADER}`;

Object.assign(UserInfo.prototype, {
    namespace: 'UserInfo',
    get(params) {
        return this.client.send('GET', baseUrl, params);
    }
});

export default UserInfo;
